//====================================================
//  Function: Basket
//====================================================
function componentBasket() {
  // BASKET IN KOSIK
  if ($(".in-kosik").length) {
    $(".cart-inner .col-md-4").prepend($(".back-shopping-link"));
    $(".cart-inner .col-md-4").addClass("card-content-group");

    $(".back-shopping-link").addClass("cart-content");

    $(".back-shopping-link a")
      .attr("title", "Návrat do eshopu")
      .addClass("btn btn--black-outline")
      .text(basketBacks);

    $(".cart-inner .col-md-8 .extras-wrapper").append(
      '<div class="extras-col extras-summary"></div>'
    );

    $(".cart-inner .col-md-8 .extras-summary").append(
      $(".cart-inner .card-content-group .price-wrapper")
    );

    if ($(".applied-coupon").length) {
      $(".applied-coupon").insertAfter($(".discount-coupon"));
    }

    if ($(".cart-table .p-discount").length) {
      $(".cart-table tr.removeable").each(function () {
        var inst = $(this);
        inst.find(".p-name").prepend(inst.find(".p-discount"));
      });
    }
  }

  // BASKET IN KROK 1
  if ($(".in-krok-1").length) {
    $(".cart-row").append('<div class="col-12 card-content-group"></div>');
    $(".card-content-group").load(
      window.location.protocol +
        "//" +
        window.location.host +
        "/kosik .checkout-box-wrapper",
      function () {
        $(".card-content-group").prepend($(".back-shopping-link"));

        $(".back-shopping-link").addClass("cart-content");

        $(".back-shopping-link a")
          .attr("title", basketBack)
          .addClass("btn btn--black-outline")
          .text(basketBack);

        $(".checkout-box-wrapper h4").html(questionBanner);

        $("#checkoutSidebar .next-step").addClass(
          "cart-content summary-wrapper"
        );
        $(".card-content-group").append($("#checkoutSidebar .next-step"));
      }
    );

    $(".order-icon.order-delivery").text(basketDelivery);
    $(".order-icon.order-payment").text(basketPayment);

    if ($(".cart-items .recapitulation-single").length) {
      // $(".cart-items .recapitulation-single strong").text("Zľavový kupón");
      $(".order-summary-inner").append($(".cart-items .recapitulation-single"));
    }

    $(".order-summary-inner h4").text(basketReca);

    $(".cart-items .cart-item").each(function () {
      var inst = $(this);
      var amount = inst.find(".cart-item-amount").text();

      inst.find(".cart-item-name a").prepend("<small>" + amount + "</>");
    });

    $("#checkoutContent").removeClass("col-md-8").addClass("col-12 col-lg-7");
    $("#checkoutSidebar").removeClass("col-md-4").addClass("col-12 col-lg-5");
  }

  // BASKET IN KROK 2
  if ($(".in-krok-2").length) {
    $(".cart-row").append('<div class="col-12 card-content-group"></div>');

    $(".card-content-group").prepend($(".back-shopping-link"));

    $(".back-shopping-link").addClass("cart-content");

    $(".back-shopping-link a")
      .attr("title", basketBack)
      .addClass("btn btn--black-outline")
      .text(basketBack);

    $(".next-step-finish").text(basketFinishTitle);

    $("#checkoutSidebar .next-step").addClass("cart-content summary-wrapper");
    $(".card-content-group").append($("#checkoutSidebar .next-step"));

    $(".order-icon.order-delivery").text(basketDelivery);
    $(".order-icon.order-payment").text(basketPayment);

    // $(".order-summary-inner").append(
    //   '<div class="order-recapitulation"></div>'
    // );

    $(".order-summary-inner > .recapitulation-single").remove();

    if ($(".cart-items .recapitulation-single").length) {
      // $(".cart-items .recapitulation-single strong").text("Zľavový kupón");
      $(".order-summary-inner").append($(".cart-items .recapitulation-single"));
    }

    $(".order-summary-inner > .recapitulation-single").wrapAll(
      '<div class="order-recapitulation"></div>'
    );

    if ($(".order-recapitulation .recapitulation-single").length == 3) {
      $(".order-recapitulation").append(
        $(".order-recapitulation .recapitulation-single:first-child")
      );
    }

    $(".order-summary-inner h4").text(basketReca);

    $(".cart-items .cart-item").each(function () {
      var inst = $(this);
      var amount = inst.find(".cart-item-amount").text();

      inst.find(".cart-item-name a").prepend("<small>" + amount + "</>");
    });

    $("#checkoutContent").removeClass("col-md-8").addClass("col-12 col-lg-7");
    $("#checkoutSidebar").removeClass("col-md-4").addClass("col-12 col-lg-5");

    $(".card-content-group").append($(".consents-first"));

    var account = $('.co-contact-information label[for="login"]').closest(
      ".form-group"
    );
    account.addClass("account-link");
    var user =
      '<svg class="icon-svg icon-user"><use xlink:href="https://www.365121.myshoptet.' +
      lang +
      '/user/documents/public/images/sprites.svg#icon-user"></use></svg>';
    account
      .find(".btn")
      .removeClass("btn-secondary")
      .addClass("btn--blue-fill")
      .html("<span class='btn-inner'>" + user + basketAccount);
    $("#checkoutContent").prepend(account);

    // ADD Question
    var question = `<div class="otazka otazka--ext txt-c">
									<h3 class="otazka__title" > ${questionBanner}</h3>
										<ul class="contact contact--side contact--side-center">
											<li class="contact__item">
												<a href="tel:+421233329713" class="contact__link">
													<span class="contact__icon">
														<svg class="icon-svg icon-phone">
															<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-phone"></use>
												</svg>
											</span>
												<span class="contact__text contact__text--highlighted">+421 2 333 29 713</span>
										</a>
									</li>
										<li class="contact__item">
											<a href="mailto:${mail}" class="contact__link">
												<span class="contact__icon">
													<svg class="icon-svg icon-mail">
														<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-mail"></use>
												</svg>
											</span>
											<span class="contact__text">${mail}</span>
										</a>
									</li >
								</ul >
							</div>`;
    $("#checkoutSidebar").append(question);
  }

  // BASKET PROCESS
  if ($(".cart-header").length) {
    $(".content-inner").prepend($(".cart-header"));

    $(".cart-header .step-2 span").text("Platba a doprava");
    $(".cart-header .step-3 span").text(basketInfoText);

    cartHeaderAddStep();
  }

  // ADD TABLE PRODUCT HEADER
  if ($(".cart-table").length) {
    var tableHeader = `<thead>
			<tr>
				<th>Produkt</th>
				<th></th>
				<th>${basketHeadAva}</th>
				<th>Cena za kus</th>
				<th>${basketHeadQuan}</th>
				<th>${basketHeadPrice}</th>
			</tr>
		</thead>`;
    $(".cart-inner .col-md-8 .cart-content .cart-table").prepend(tableHeader);
  }

  if ($(".in-kosik .cart-header").length) {
    $(".cart-inner .col-md-8 .cart-content").prepend(
      "<div class='basket-header-title'>" + basketTitle + "</div>"
    );
  }

  // Load Product label
  if ($(".cart-table").length) {
    $(".cart-table tr.removeable").each(function () {
      var inst = $(this);
      var productName = inst.find(".p-name");
      var productLink = inst.find(".main-link").attr("href");
      productName.prepend('<span class="flags-group"></span>');
      var flagsGroup = inst.find(".flags-group");

      flagsGroup.load(
        window.location.protocol +
          "//" +
          window.location.host +
          productLink +
          " .product-top .flags-default .flag",
        function () {}
      );
    });
  }

  // Discount coupon
  if ($(".discount-coupon").length) {
    var discountCoupon =
      '<svg class="icon-svg icon-voucher"><use xlink:href="https://www.365121.myshoptet.' +
      lang +
      '/user/documents/public/images/sprites.svg#icon-voucher"></use></svg>';
    $(".discount-coupon").prepend(
      '<div class="discount-coupon-text-block">' +
        discountCoupon +
        '<div class="discount-coupon-text">' +
        basketDiscountText +
        "</div></div>"
    );

    $(".discount-coupon input").attr("placeholder", "Vložte kód");
    $(".discount-coupon .btn").text(basketDiscountIns);
  }

  // SUMMARY
  if ($(".extras-summary .price-label.price-primary").length) {
    $(".extras-summary .price-label.price-primary").text("CENA S DPH:");
  }

  // BASKET DELIVERY
  if ($(".in-krok-2").length) {
    $(".co-contact-information h4").text(basketTitleUser);
    $(".co-billing-address h4").text(basketdod);
    // $(".company-shopping").insertAfter($(".co-billing-address .box"));
    // $("#company-info").insertAfter($(".company-shopping"));
    $(".company-shopping label").text(basketCompany);

    // var noteTextarea = $("#note textarea");

    // var noteForm = `<div class="form-group is-required note-group">
    // 			<label for="remark">
    // 				<span class="required-asterisk">Poznámka</span>
    // 			</label>
    //   	</div>`;
    // $(".co-billing-address .box").append(noteForm);
    // $(".note-group").append(noteTextarea);

    // $("#add-note").closest(".form-group").remove();
  }

  if ($(".cart-empty").length) {
    $(".card-content-group .cart-content").addClass(
      "checkout-box-wrapper checkout-box-wrapper--ext"
    );
  }
}
